import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import Link from '@src/components/link';
import toWebpImage from '@src/utils/to-webp-image';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import BackTopFooter from '@src/business-components/backtop-footer';
import NaviBar from '@src/business-components/navibar';
import { $$tracker } from '@src/tracker';

const styles = require('./index.less');
const lang = getLanguageByPath() === 'zh-Hant' ? 'tc' : getLanguageByPath();
const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <Page className={styles.root}>
      <NaviBar store={store.naviBarStore} />
      <div className={styles.content}>
        <div className={styles.line} />
        <Link
          className={styles.item}
          onClick={() => {
            store.more('wordView');
            $$tracker.clickHomeTheWorld();
          }}
        >
          <div className={styles.worldviewImg} style={{ backgroundImage: `url(${toWebpImage(require(`./images/${lang}/worldviewImg.png`))})` }} />
          <div className={styles.worldviewImgActive} style={{ backgroundImage: `url(${toWebpImage(require(`./images/${lang}/worldviewImgActive.png`))})` }} />
        </Link>
        <Link
          className={styles.item}
          onClick={() => {
            store.more('chronicle');
            $$tracker.clickHomeTimeLine();
          }}
        >
          <div className={styles.chronicleImg} style={{ backgroundImage: `url(${toWebpImage(require(`./images/${lang}/chronicleImg.png`))})` }} />
          <div className={styles.chronicleImgActive} style={{ backgroundImage: `url(${toWebpImage(require(`./images/${lang}/chronicleImgActive.png`))})` }} />
        </Link>
      </div>
      {/* 底部版权栏 */}
      {<BackTopFooter btns={['copyright']} />}
    </Page>
  );
};

export default observer(Main);
